module.exports = __webpack_public_path__ + "static/media/Screenshot1.b70c989a.png";